"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultVideoStreamIdSet_1 = require("../videostreamidset/DefaultVideoStreamIdSet");

var NoVideoDownlinkBandwidthPolicy = /*#__PURE__*/function () {
  function NoVideoDownlinkBandwidthPolicy() {
    _classCallCheck(this, NoVideoDownlinkBandwidthPolicy);
  }

  _createClass(NoVideoDownlinkBandwidthPolicy, [{
    key: "reset",
    value: function reset() {}
  }, {
    key: "updateIndex",
    value: function updateIndex(_videoIndex) {}
  }, {
    key: "updateMetrics",
    value: function updateMetrics(_clientMetricReport) {}
  }, {
    key: "wantsResubscribe",
    value: function wantsResubscribe() {
      return false;
    }
  }, {
    key: "chooseSubscriptions",
    value: function chooseSubscriptions() {
      return new DefaultVideoStreamIdSet_1.default();
    }
  }]);

  return NoVideoDownlinkBandwidthPolicy;
}();

exports.default = NoVideoDownlinkBandwidthPolicy;